import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Building2, CreditCard, Receipt, LogOut, Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { clearToken } from "../lib/api";

const NAV = [
    { to: "/shop", label: "Shop Details", icon: Building2, end: true },
    { to: "/shop/subscription", label: "Subscription & Payments", icon: CreditCard },
    { to: "/shop/payments", label: "Payment History", icon: Receipt },
];

export const Sidebar = ({ shopName, adminName }) => {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const logout = () => {
        clearToken();
        navigate("/login");
    };

    return (
        <>
            {/* Mobile menu button */}
            <button
                data-testid="sidebar-toggle"
                className="md:hidden fixed top-4 left-4 z-50 p-2 rounded-lg ap-card-soft"
                onClick={() => setOpen(!open)}
            >
                {open ? <X size={20} /> : <Menu size={20} />}
            </button>

            <aside
                data-testid="app-sidebar"
                className={`fixed md:sticky top-0 left-0 h-screen w-72 z-40 transition-transform
                    ${open ? "translate-x-0" : "-translate-x-full"} md:translate-x-0
                    flex flex-col p-6 border-r`}
                style={{ background: "var(--ap-bg-2)", borderColor: "var(--ap-line)" }}
            >
                <Logo size={40} />

                <div className="mt-8 px-2">
                    <div className="ap-label mb-1">Auto Shop Owner / Manager</div>
                    <div className="text-base font-semibold text-white truncate" data-testid="header-shop-name">
                        {shopName || "—"}
                    </div>
                    <div className="text-xs mt-1" style={{ color: "var(--ap-text-dim)" }}>
                        {adminName || ""}
                    </div>
                </div>

                <nav className="mt-8 flex-1 flex flex-col gap-1">
                    {NAV.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            end={item.end}
                            data-testid={`nav-${item.to.replace(/\//g, "-")}`}
                            onClick={() => setOpen(false)}
                            className={({ isActive }) =>
                                `flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-colors ${
                                    isActive
                                        ? "text-white"
                                        : "text-slate-400 hover:text-white hover:bg-white/5"
                                }`
                            }
                            style={({ isActive }) =>
                                isActive
                                    ? {
                                          background:
                                              "linear-gradient(180deg, rgba(37,99,235,0.25), rgba(37,99,235,0.1))",
                                          borderLeft: "2px solid var(--ap-blue-2)",
                                      }
                                    : {}
                            }
                        >
                            <item.icon size={18} />
                            {item.label}
                        </NavLink>
                    ))}
                </nav>

                <button
                    data-testid="logout-btn"
                    onClick={logout}
                    className="mt-4 ap-btn-ghost flex items-center gap-2 justify-center"
                >
                    <LogOut size={16} /> Sign out
                </button>
            </aside>

            {open && (
                <div
                    onClick={() => setOpen(false)}
                    className="md:hidden fixed inset-0 bg-black/60 z-30"
                />
            )}
        </>
    );
};
